export default __webpack_public_path__ + "static/media/(3).ff5f8889.jpeg";